import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as Ant from 'antd';
import ProductItem from '../../Components/ProductItem';
import * as JStorage from '../../JStorage';
import * as AppActions from '../../AppActions';
import {useOutlet} from 'reconnect.js';
import useDocuments from '../../Hooks/useDocuments';
import qs from 'query-string';
import TdaCategoryTree from '../../Components/TdaCategoryTree';
import useArea from '../../Hooks/useArea';
import * as NavUtil from '../../Utils/NavUtil';
import {routes} from '../../Utils/ProductUtil';
import Breadcrumb from '../../Components/Breadcrumb';
import {Link} from 'gatsby';

function Questions(props) {
  const {location} = props;
  const params = qs.parse(location.search) || {};
  const [landing] = useOutlet('landing');
  const {area, isDoctorByPathname} = useArea();
  const isDoctor = isDoctorByPathname(props.location.pathname);
  const route = routes[isDoctor ? 'doctor' : 'people'].categories
    .map((x) => ({...x, path: x.url}))
    .find((x) =>
      params.cat
        ? x.name === params.cat
        : params.reg_online
        ? x.name === '線上報名'
        : NavUtil.isNavLinkSelected(x),
    ); // for fit 課程活動、活動快訊、福利活動...等
  const [answer, setAnswer] = React.useState();

  const {records, total, refresh, filters, setFilters} = useDocuments({
    collection: 'questionnaire',
    defaultFilters: {
      ...(params.date
        ? {
            start_date: {$lte: params.date},
            end_date: {$gte: params.date},
          }
        : {
            start_date: {$lte: new Date().toLocaleString('sv')},
            end_date: {$gte: new Date().toLocaleString('sv')},
          }),
      ...(params.reg_online ? {reg_online: true} : {reg_online: undefined}),
    },
    sorting: ['start_date'],
  });

  async function getAns() {
    const _answer = await JStorage.fetchAllDocuments('questionnaire_answer');
    setAnswer(_answer);
  }

  React.useEffect(() => {
    refresh();
    getAns();
  }, [refresh]);

  React.useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      ...(params.reg_online ? {reg_online: true} : {reg_online: undefined}),
      offset: 0,
    }));
  }, [params.cat, params.reg_online, isDoctor]);

  return (
    <Wrapper>
      <main className="tda-layout">
        <section className="nav">
          <TdaCategoryTree
            title="活動看板"
            root={routes[isDoctor ? 'doctor' : 'people']}
            location={props.location}
            checkSelected={({name, url}) =>
              params.cat
                ? name === params.cat
                : params.reg_online
                ? name === route.name
                : NavUtil.sliceTailSlash(url) ===
                  NavUtil.sliceTailSlash(props.location.pathname)
            }
          />
        </section>
        <section className="content">
          <div className="tda-header">
            <h2>{params?.date || route?.name}</h2>
            <Breadcrumb third={params?.date || route?.name} />
          </div>

          <Ant.Table
            dataSource={records}
            columns={[
              {
                title: '問卷名稱',
                key: 'title',
                render: (it, record) => {
                  const ansCount = answer?.filter(
                    (it) => it.questionnaire_id === record.id,
                  ).length;

                  const isDisabled =
                    it.max_respondents !== 0 && ansCount >= it.max_respondents;

                  return (
                    <div>
                      <Link
                        disabled={isDisabled}
                        onClick={(e) => {
                          if (isDisabled) {
                            e.preventDefault();
                          }
                        }}
                        style={{fontWeight: 'bold', fontSize: 16}}
                        to={`/${area}/events/questionnaire/?id=${it.id}`}>
                        {it.title}
                      </Link>
                    </div>
                  );
                },
              },
              {
                title: '填寫對象',
                key: 'answer_role',
                render: (it) => {
                  let output;
                  switch (it.answer_role) {
                    case 'all':
                      output = '所有人';
                      break;
                    case 'member':
                      output = '限會員';
                      break;
                    case 'specific':
                      output = '限選擇對象';
                      break;
                  }
                  return <div>{output}</div>;
                },
              },
              {
                title: '尚可填寫份數',
                key: 'max_respondents',
                render: (it, record) => {
                  const ansCount = answer?.filter(
                    (it) => it.questionnaire_id === record.id,
                  ).length;
                  return (
                    <div>
                      {it.max_respondents === 0
                        ? '無限制'
                        : it.max_respondents - ansCount}
                    </div>
                  );
                },
              },
              {
                title: '問卷統計',
                key: 'action',
                render: (it) => {
                  if (it.public_answer) {
                    return (
                      <Ant.Button
                        onClick={() => {
                          AppActions.navigate(
                            `/doctor/events/questionnaire-statistics?id=${it.id}`,
                          );
                        }}>
                        查看
                      </Ant.Button>
                    );
                  } else {
                    return <div>未開放</div>;
                  }
                },
              },
            ]}
            rowKey={'id'}
            pagination={{
              total,
              pageSize: filters.limit,
              current: filters.offset / filters.limit + 1,
            }}
            onChange={({pageSize, current}) => {
              setFilters((prev) => ({
                ...prev,
                offset: (current - 1) / prev.limit,
              }));
            }}
          />
        </section>
      </main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);
`;

export default withPageEntry(Questions);
